export default __webpack_public_path__ + "media/images/coworkr/favicons/icon57-f4dbcc9470bdfe3292deefc250ee9870.png";